import { defineMessages } from 'react-intl';

export default defineMessages({
    blankPlaceholder: {
        id: 'wmic-pe-components-platform-react.common.Blank Placeholder',
        defaultMessage: '-',
    },
    blankPlaceholderAriaLabel: {
        id: 'wmic-pe-components-platform-react.common.Blank Placeholder Aria Label',
        defaultMessage: 'No value',
    },
});
